import type { Currency } from '@backmarket/http-api'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

export function useUpdateTrackingUserContext() {
  return {
    updateTrackingUserContext: () => {
      const { user, isUserAuthenticatedStaff } = useUserStore()
      const { isImpersonated } = useSellerInfoStore()
      const tracking = useTracking()
      const logger = useLogger()
      const currentMarketplace = useMarketplace().market.marketplace

      if (!user.value.userId) {
        return
      }

      try {
        tracking.setUserContext({
          userId: user.value.userId,
          isStaff: isImpersonated || isUserAuthenticatedStaff.value,
          clientId: user.value.clientId,
          bmUserId: user.value.bmUserId,
          merchantId: user.value.merchantId
            ? user.value.merchantId.toString() + currentMarketplace
            : '',
          emailHashed: user.value.emailHashed || '',
          numberOfOrders: user.value.numberOfOrders,
          lastOrderDate: String(user.value.lastOrderDate),
          lifetimeRevenue: {
            currency: <Currency>user.value.lifetimeRevenue.currency || '',
            amount: String(user.value.lifetimeRevenue.amount),
          },
        })
      } catch (err) {
        const error = err as Error
        logger.error(error.message, {
          error,
          owners: ['bot-squad-seller-experience-front'],
        })

        return
      }

      if (!user.value.clientId) {
        return
      }

      if (user.value.bmUserId) {
        tracking.setCrmId(user.value.bmUserId)
      } else {
        logger.error(
          '[LIF][CRM][UserContext] Missing bmUserId for authenticated client',
          {
            userId: user.value.userId ?? '',
            feature: 'braze-crm-integration',
            owners: ['bot-squad-lifecycle-front'],
          },
        )
      }
    },
  }
}
